import type { PlainDatePeriodRestProps } from 'app/common/ui-components/filter'
import SimpleDate, { Units } from 'app/common/classes/simple-date'
import { type State } from 'app/common/ui-components/filter'
import { flags as groupComplexesSpecial } from '../groupComplexesSpecial'

const disabledDays = (dayFormatted: string, format: string, unit: Units = Units.day) => {
  const day = new SimpleDate(dayFormatted, format)
  const today = SimpleDate.createToday()
  return day.isAfter(today, unit)
}

const periodProps = (state: State): PlainDatePeriodRestProps => {
  const isOnlyMonthMightSelect =
    groupComplexesSpecial.byItemsAndComplexesAndCostSelected(state) ||
    groupComplexesSpecial.byPaymentMethodSelected(state)

  const additionalProps = isOnlyMonthMightSelect
    ? {
        periodLimit: 30,
        periodLimitUnit: 'days',
      }
    : {}

  return {
    label: 'Период времени',
    buttonResetLabel: 'Сбросить выбор',
    fromLabel: 'от',
    toLabel: 'до',
    dateDisabledStatus: disabledDays,
    ...additionalProps,
  }
}

export default periodProps
